import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  TEMPLATES_REFRESH: createSagaAction('TEMPLATES_REFRESH'),
  LOAD_SAVED_TEMPLATE: createSagaAction('LOAD_SAVED_TEMPLATE'),
  CREATE_NEW_TEMPLATE: createSagaAction('CREATE_NEW_TEMPLATE'),
  UPDATE_SAVED_TEMPLATE: createSagaAction('UPDATE_SAVED_TEMPLATE'),
  DELETE_SAVED_TEMPLATE: createSagaAction('DELETE_SAVED_TEMPLATE'),

  CREATE_NEW_TEMPLATE_WITH_ATTACHMENT: createSagaAction('CREATE_NEW_TEMPLATE_WITH_ATTACHMENT'),
  SAVE_TEMPLATE_WITH_ATTACHMENT: createSagaAction('SAVE_TEMPLATE_WITH_ATTACHMENT')
}

// Action Creators
export const actions = {
  templatesRefresh: ({ templateType }) => ({
    type: constants.TEMPLATES_REFRESH.ACTION,
    templateType
  }),
  getTemplateById: ({ templateType, templateId }) => ({
    type: constants.LOAD_SAVED_TEMPLATE.ACTION,
    templateType,
    templateId
  }),
  createTemplate: templateInfo => ({
    type: constants.CREATE_NEW_TEMPLATE.ACTION,
    ...templateInfo
  }),
  saveTemplate: templateInfo => ({
    type: constants.UPDATE_SAVED_TEMPLATE.ACTION,
    ...templateInfo
  }),
  deleteTemplate: ({ templateId, templateType }) => ({
    type: constants.DELETE_SAVED_TEMPLATE.ACTION,
    templateId,
    templateType
  }),
  createTemplateWithAttachment: formData => ({
    type: constants.CREATE_NEW_TEMPLATE_WITH_ATTACHMENT.ACTION,
    ...formData
  }),
  saveTemplateWithAttachment: ({ formData, templateId }) => ({
    type: constants.SAVE_TEMPLATE_WITH_ATTACHMENT.ACTION,
    formData,
    templateId
  })
}
// Reducer
const initialState = [
  {
    loadingTemplate: true
  }
]

export default createReducer(initialState, (state, { type, payload }) => {
  switch (type) {
    default:
      return state
    case constants.TEMPLATES_REFRESH.SUCCESS:
      return { ...state, payload }
    case constants.LOAD_SAVED_TEMPLATE.ACTION:
      return { ...state, loadingTemplate: true }
    case constants.LOAD_SAVED_TEMPLATE.SUCCESS:
      return { ...state, loadedTemplate: payload, loadingTemplate: false }
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/templatesActions.js